module.exports = __webpack_public_path__ + "img/ctrl-bwecp-stub-down--i.eb2ee665.svg";